<template>
    <div>
        <Loading v-model:active="isLoading" v-model="fullPage"
       :can-cancel="true"
       :on-cancel="onCancel"
       :is-full-page="fullPage" />

        <v-container>
            <v-row>
            <v-col cols="12" md="12" lg="4" xl="4" style="text-align:center;">
                <h4>Activities</h4>
                <v-timeline side="end" align="start">
                    <v-timeline-item v-for="item in this.$store.getters.activeIdData.activities" dot-color="pink" size="small">
                        <div class="d-flex">
                            <strong class="me-4">{{ item[0] }}</strong>
                            <div>
                              <strong></strong>
                              <div class="text-caption">
                                {{ item[1] }}
                              </div>
                            </div>
                        </div>
                    </v-timeline-item>
                </v-timeline>
            </v-col>

            <v-col cols="12" md="12" lg="4" xl="4" style="text-align:center;">
                <v-toolbar dark color="#0086d0" style="padding:0;text-align:left;height:40px;" density="compact">
                    <v-toolbar-title style="font-size:16px;color:#fff;padding:0;margin:0;margin-left:10px;">Medical Report</v-toolbar-title>
                </v-toolbar>
                <div class="show-id-personal-data-table">
                    <v-table @click:row="handleClick" v-for="item in id_data"
                            :key="item.id">
                        <tbody>
                            <tr><td>ID</td><td class="text-left">{{ item.id }}</td></tr>
                            <tr><td>Surname</td><td class="text-left">{{ item.surname }}</td></tr>
                            <tr><td>First Name</td><td class="text-left">{{ item.first_name }}</td></tr>
                            <tr><td>Birth date</td><td class="text-left">{{ item.birth_date }}</td></tr>
                        </tbody>
                    </v-table>
                </div>
            </v-col>
            <v-col cols="12" md="12" lg="4" xl="4" style="text-align:center;">
                <v-toolbar dark color="#0086d0" style="padding:0;text-align:left;height:40px;" density="compact">
                    <v-toolbar-title style="font-size:16px;color:#fff;padding:0;margin:0;margin-left:10px;">Statistics</v-toolbar-title>
                </v-toolbar>
                <v-card class="elevation-2">
                </v-card>
            </v-col>

            </v-row>
        </v-container>
    </div>
</template>
<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: {
      Loading
    },
    props: {
        id: String,
        server_path: String,
        module_server: String,
        methods_get_patients: String,
        methods_get_id_data: String
    },
    data : function () {
      return {
        message: '',
        id_data: [],
        pid: ''
      }
    },
    methods: {
        getIDDataFull() {
            
            this.isLoading = true;
                setTimeout(() => {
                this.isLoading = false
            }, 20000)

            var url = this.module_server +this.methods_get_id_data + "?id=" + this.id

            //axios.post(url, requestData)
            axios.get(url)
                .then((response) => {
                    this.res = response;
                    this.hide=false;

                    var obj_str = JSON.stringify(this.res.data);
                    this.id_data = JSON.parse(obj_str);

                    //this.addResponseItem();

                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.message = 'error '+this.patients;
                })
        }
    },
    created: async function() {
        this.pid = this.$route.query.id
    },
    beforeCreate:async function() {
      //this.id = this.$route.query.id
      //this.$store.dispatch('setIdData',this.$route.query.id)
    },
    mounted: function () {
    },
}

</script>
<style>
.plain_title {
  color:#000000;
  text-decoration: None;
}
</style>